<script>
import { Line, mixins } from 'vue-chartjs'
import { mapGetters } from 'vuex'

export default {
  extends: Line,
  props: ['chartData'],
  mounted () {
    let options = {
      responsive: true,
      maintainAspectRatio: false,
      height: 300,
      legend: { display: false },
      scales: {
        xAxes: [{
          gridLines: {
            drawOnChartArea: false
          }
        }],
         yAxes: [{
             ticks: {
                 beginAtZero: true,
                 userCallback: function(label, index, labels) {
                     // when the floored value is the same as the value we have a whole number
                     if (Math.floor(label) === label) {
                         return label;
                     }

                 },
             }
         }],
     }
    }
    this.renderChart(this.chartData, options)
  }
}
</script>
